import { createFileRoute } from '@tanstack/react-router'
import { ShieldCheck } from 'lucide-react'
import { z } from 'zod'
import { SecurityScreen } from '@/screens/me/SCR-123-security'

export const Route = createFileRoute('/_app/me/security')({
  staticData: { screen: { id: 'SCR-123', title: 'Security', group: 'Me', order: 5, description: 'Password, two-step sign-in and where you are signed in.', icon: ShieldCheck } },
  validateSearch: z.object({ enrol: z.coerce.number().int().min(0).max(1).optional() }),
  component: SecurityScreen,
})
